/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken } from '../utils/util';
import './ManageCompany.css';
import Wrapper from './Wrapper';
import OzModalButton from './partials/OzModalButton';
import EditableCompany from './partials/EditableCompany';
import { SITE_DOMAIN } from '../config';

import {
  fetchUser,
  getCompany,
  listCompanies,
  updateRoom,
  addIntegration,
  pullMyData,
  addLocation,
  updateLocation,
} from '../actions';


class ManageCompany extends OzComponent {

  static need = [
    ['user', fetchUser],
  ];

  state = {};

  render() {
    return (
      <Wrapper className="ManageLocation" title="Manage Company">
        <EditableCompany
          companyId={this.props.params.id}
        />
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listCompanies,
    updateRoom,
    addIntegration,
    pullMyData,
    addLocation,
    updateLocation,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageCompany);



/** WEBPACK FOOTER **
 ** ./src/components/ManageCompany.js
 **/